import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { Typography } from '../../../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { pixelToRem } from '../../../../utils/functions/pixelToRem/pixelToRem.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../components/IconButton/IconButton.js';
import { iconRatio, IconWithSpinner } from '../../../../components/IconWithSpinner/IconWithSpinner.js';
import { WidgetPortal } from '../../components/WidgetPortal/WidgetPortal.js';

const PendingAccountSwitchModal = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    useEffect(() => {
        const disconnectAndConnect = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if ((selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.connectedChain) !== 'FLOW')
                return;
            yield ((_a = selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.endSession) === null || _a === void 0 ? void 0 : _a.call(selectedWalletConnector));
            (_b = selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.connect) === null || _b === void 0 ? void 0 : _b.call(selectedWalletConnector);
        });
        disconnectAndConnect();
    }, [selectedWalletConnector]);
    const icon = (jsx(WalletIcon, { walletName: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name, style: {
            height: pixelToRem(96 * iconRatio),
            width: pixelToRem(96 * iconRatio),
        } }));
    return (jsxs(WidgetPortal, { children: [jsx("div", Object.assign({ className: 'pending-account-switch-modal__prompt' }, { children: jsx(IconWithSpinner, { isSpinning: true, iconSize: 96, Icon: icon }) })), jsxs("div", Object.assign({ className: 'pending-account-switch-modal__content' }, { children: [jsx(Typography, Object.assign({ className: 'pending-account-switch-modal__title', color: 'primary', variant: 'body_normal', as: 'h6' }, { children: "Switch Connected Account" })), jsx(Typography, Object.assign({ variant: 'body_small', as: 'p', color: 'secondary', weight: 'regular', className: 'pending-account-switch-modal__text' }, { children: "To switch accounts within the same wallet, we need you to first switch the connected account in your wallet." }))] }))] }));
};

export { PendingAccountSwitchModal };
